module.exports = __webpack_public_path__ + "ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ca.svg
// module id = 477
// module chunks = 0